import { Head, Link } from '@inertiajs/react'
import { Button } from '@/components/ui/button'

interface SetSummary {
  id: number
  name: string
  tune_count: number
}

interface Props {
  sets: SetSummary[]
}

export default function Index({ sets }: Props) {
  return (
    <>
      <Head title="Sets" />

      <div className="mb-6 flex items-center justify-between">
        <h1 className="font-display text-2xl font-semibold tracking-tight">Sets</h1>
        <Button asChild>
          <Link href="/sets/new">New set</Link>
        </Button>
      </div>

      {sets.length === 0 ? (
        <p className="text-sm text-muted-foreground">
          No sets yet. Group a few tunes into a set to play them back-to-back.
        </p>
      ) : (
        <ul className="divide-y rounded-lg border">
          {sets.map((set) => (
            <li key={set.id}>
              <Link
                href={`/sets/${set.id}`}
                className="flex items-center justify-between gap-3 px-4 py-3 hover:bg-accent"
              >
                <span className="font-display font-medium">{set.name}</span>
                <span className="text-sm text-muted-foreground">
                  {set.tune_count} {set.tune_count === 1 ? 'tune' : 'tunes'}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </>
  )
}
